'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');
var isAuthenticated = $('#isAuthenticated').val() === 'true';

/**
 * Initializes the title dropdown with a default selected option.
 *
 * - Finds the first available option in the custom dropdown
 * - Sets its text as the visible selected value
 * - Stores its code in the hidden input field
 * - Marks the option as selected
 *
 * @function initializeTitleDropdown
 * @returns {void}
 */
function initializeTitleDropdown() {
    var $dropdown = $('.form-firstname-dropdown');
    var $selectedValue = $dropdown.find('.selected-value');
    var $hiddenInput = $('#catalogueTitle');
    var $firstOption = $dropdown.find('.custom-option-value').first();
    if ($firstOption.length) {
        var defaultValue = $firstOption.data('code');
        var defaultText = $firstOption.text();
        $selectedValue.text(defaultText);
        $hiddenInput.val(defaultValue);
        $firstOption.siblings('.custom-option-value').removeClass('selected');
        $firstOption.addClass('selected');
    }
}

/**
 * Validates a guest checkout field using contextual rules (name, email, phone, or generic required checks).
 * @param {JQuery} $field - The input/select element wrapped in jQuery whose value should be validated.
 * @returns {boolean} True when the field value complies with its rules; otherwise false with feedback applied.
 */
function Validate($field) {
    var value = $field.val();
    var isValid = true;
    var errorMsg = '';
    var $errorDiv;
    var fieldId = $field.attr('id');
    var isNameField = fieldId === 'catalogueFirstName' || fieldId === 'catalogueLastName';
    var isEmailField = $field.attr('type') === 'email';
    var isPhoneField = $field.attr('type') === 'tel';

    if (isNameField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var pattern = /^[A-Za-z][A-Za-z\s]*$/;
        if (isValid && value && !pattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('invalid-error');
        }
    } else if (isEmailField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9@._-]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var emailPattern = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (isValid && value && !emailPattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('pattern-mismatch') || 'Please enter a valid email address';
        }
    } else if (isPhoneField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);
        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var requiredLength = parseInt($field.attr('data-phonelength'), 10)
            || parseInt($field.attr('maxlength'), 10)
            || 10;

        var countryCode = $field.attr('data-countrycode');

        if (countryCode === '+91' && value.length > 0) {
            if (!/^[6-9]/.test(value)) {
                $field.val('');
                value = '';
                isValid = false;
                errorMsg = $field.data('format-error');
            }
        }

        if (isValid && value.length !== requiredLength) {
            isValid = false;
            errorMsg = 'Enter valid ' + requiredLength + '-digit phone number';
        }
    } else {
        value = value.trim();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }
    }

    $errorDiv = $field.siblings('.invalid-feedback');

    if (!isValid) {
        $field.addClass('is-invalid');
        $errorDiv.text(errorMsg).show();

        if ($field.hasClass('firstname-input')) {
            $('.form-firstname-dropdown .custom-drop-down').addClass('is-invalid');
        }

        if ($field.hasClass('phone-input')) {
            $('.form-group-phone .custom-drop-down-section').addClass('is-invalid');
        }
    } else {
        $field.removeClass('is-invalid');
        $errorDiv.text('').hide();

        if ($field.hasClass('firstname-input')) {
            $('.form-firstname-dropdown .custom-drop-down').removeClass('is-invalid');
        }

        if ($field.hasClass('phone-input')) {
            $('.form-group-phone .custom-drop-down-section').removeClass('is-invalid');
        }
    }

    return isValid;
}

$(document).on('click', '#catalogueRequestForm .requestcatalogue-fname-group .custom-option-value', function () {
    var $this = $(this);
    var value = $this.data('code');
    var text = $this.text();
    $('#catalogueTitle').val(value);
    $this.closest('.custom-drop-down-section').find('.selected-value').text(text);
});

$('body').on('click', '#requestCatalogueModal .country-code .custom-option-value', function () {
    var $this = $(this);
    var countryCode = $this.data('id');
    var phoneLength = $this.data('phonelength');
    var $phoneInput = $('#cataloguePhone');
    $phoneInput.attr('data-countrycode', countryCode);
    $this.closest('.custom-drop-down-section').find('.selected-value').text(countryCode);
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    if (phoneLength) {
        $phoneInput.attr('maxlength', phoneLength);
    }
    $phoneInput.val('');
    $phoneInput.removeClass('is-invalid');
    $('.form-group-phone .custom-drop-down-section').removeClass('is-invalid');
    $phoneInput.siblings('.invalid-feedback').text('').hide();
});

/**
 * Updates the submit button text based on the current viewport width.
 *
 * - Stores the original button text (once) using jQuery `data` so it can be restored later.
 * - Sets the button text to "Add" for mobile/tablet viewports (< 1024px).
 * - Restores the original text for desktop viewports (≥ 1024px).
 *
 * Safely exits if the submit button is not present in the DOM.
 *
 * @function updateSubmitButtonText
 * @returns {void}
 */
function updateSubmitButtonText() {
    var $submitBtn = $('#submitCatalogueRequestBtn');
    if ($submitBtn.length === 0) return;
    var originalText = $submitBtn.data('original-text');
    if (!originalText) {
        originalText = $submitBtn.text().trim();
        $submitBtn.data('original-text', originalText);
    }
    $submitBtn.text(originalText);
}

$('body').on('shown.bs.modal', '#requestCatalogueModal', function () {
    initializeTitleDropdown();
    var $countryDropdown = $('#requestCatalogueModal .country-code .custom-drop-down-section');
    var $selectedValue = $countryDropdown.find('.selected-value');
    var $indiaOption = $countryDropdown.find('.custom-option-value[data-id="+91"]');
    if ($indiaOption.length) {
        $selectedValue.text('+91');
        $indiaOption.siblings('.custom-option-value').removeClass('selected');
        $indiaOption.addClass('selected');
    }
    var $submitBtn = $('#submitCatalogueRequestBtn');
    if (!$submitBtn.data('original-text')) {
        $submitBtn.data('original-text', $submitBtn.text().trim());
    }
    updateSubmitButtonText();
});

$('body').on('change input blur', '#catalogueRequestForm input', function () {
    Validate($(this));
});

$('body').on('input', '#catalogueEmail, #catalogueFirstName, #catalogueLastName, #catalogueMessage', function () {
    var $field = $(this);
    var value = $field.val();
    var cleanedValue = value.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
    if (value !== cleanedValue) {
        $field.val(cleanedValue);
    }
});

$('body').on('blur', '#catalogueMessage', function () {
    var $field = $(this);
    if ($field.val().trim() === '') {
        $field.addClass('is-invalid');
        $field.siblings('.invalid-feedback').text($field.data('missing-error')).show();
    }
});

$('body').on('input', '#catalogueMessage', function () {
    var $field = $(this);
    var value = $field.val().trim();
    if (value) {
        $field.removeClass('is-invalid');
        $field.siblings('.invalid-feedback').text('').hide();
    }
});

/**
 * Submits the catalogue request form data via AJAX.
 *
 * - Sends the form data to the server using a POST request
 * - Closes the request modal on successful submission
 * - Displays a success toast and opens the success modal
 * - Shows a generic error notification on failure
 *
 * @function submitCatalogueRequest
 * @param {Object|FormData} formData - Serialized form data or FormData object to be submitted
 * @returns {void}
 */
function submitCatalogueRequest(formData) {
    var modaldataurl = $('#requestCatalogueModal').data('url');
    var url = modaldataurl;
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: formData,
        success: function (response) {
            if (response.success) {
                $('#requestCatalogueModal').modal('hide');
                $('#requestSuccessModal').modal('show');
                $.spinner().stop();
            } else {
                $('#requestCatalogueModal').modal('hide');
                var $alreadyHaveResponseModal = $('#allreadyhaveresponserequestcatalogue');
                $alreadyHaveResponseModal.modal('show');
                $alreadyHaveResponseModal.find('.modal-body .message-text').text(response.errormessage);
                setTimeout(function () {
                    $alreadyHaveResponseModal.modal('hide');
                }, 5000);
                $.spinner().stop();
            }
        },
        error: function () {
            toastMessageHelper.showNotification('Something went wrong. Please try again later.');
        }
    });
}

/**
 * Resets the catalogue request form to its initial state.
 *
 * - Clears all form field values manually
 * - Removes validation error styles from inputs
 * - Hides all validation error messages
 * - Re-initializes the title dropdown with its default value
 *
 * @function clearForm
 * @returns {void}
 */
function clearForm() {
    $('#catalogueFirstName, #catalogueLastName, #catalogueEmail, #cataloguePhone, #catalogueMessage').val('');
    $('.catalogue-form-input').removeClass('is-invalid');
    $('.invalid-feedback').text('');
    $('.invalid-error-message').text('');
    $('.form-check-label.placeholder').removeClass('d-none');
    initializeTitleDropdown();
}

/**
 * Resets the phone country code selection in the request catalogue form UI.
 *
 * Updates the displayed selected value, clears any prior selected states,
 * applies selection to the resolved default option, and hides the dropdown list.
 * If a `countryCode` is provided, it attempts to select the matching option by `data-id`;
 * otherwise it selects the first available option in the list.
 *
 * @function resetCountryCodeToDefault
 * @param {string} [countryCode] - Country calling code (matched against `.custom-option-value[data-id]`).
 * @returns {void}
 */
function resetCountryCodeToDefault(countryCode) {
    var requestCatalogFormCountryCode = countryCode || '';
    var $container = $('.form-group-phone');
    var $defaultOption;

    // If countryCode is passed → use it
    if (requestCatalogFormCountryCode) {
        $defaultOption = $container
            .find('.custom-option-value[data-id="' + requestCatalogFormCountryCode + '"]')
            .first();
    } else { // Else → pick FIRST option from the list
        $defaultOption = $container.find('.custom-option-value').first();
    }

    if ($defaultOption.length) {
        var defaultCode = $defaultOption.data('id');

        // Update display
        $container.find('.selected-value, .country-selected-value')
            .text(defaultCode)
            .addClass('active');

        // Reset selected states
        $container.find('.custom-option-value, .country-option-item')
            .removeClass('selected');

        $defaultOption.addClass('selected');
        $container.addClass('selected');

        // Hide dropdown
        $container.find('.custom-option-values, .country-dropdown-options').hide();
    }

    if (countryCode) {
        var $phoneInput = $('#cataloguePhone');
        var phoneLength = $('#catalogueRequestForm .custom-option-value.custom-option-login.selected').data('phonelength');
        $phoneInput.attr('maxlength', phoneLength);
        $phoneInput.attr('data-countrycode', countryCode);
        $container.find('.custom-drop-down-section').addClass('non-editable');
    }
}

$('body').on('click', '#submitCatalogueRequestBtn', function (e) {
    e.preventDefault();
    var $form = $('#catalogueRequestForm');
    var $scrollContainer = $('#requestCatalogueModal .modal-body');
    var isFormValid = true;
    var scrollTarget = null;
    $form.find('input').each(function () {
        var $input = $(this);
        if (!Validate($input)) {
            isFormValid = false;
            if (!scrollTarget) {
                scrollTarget = $input;
            }
        }
    });

    var $messageField = $('#catalogueMessage');
    var messageValue = $messageField.val().trim();
    var $messageError = $messageField.siblings('.invalid-feedback');

    if (!messageValue) {
        isFormValid = false;
        $messageField.addClass('is-invalid');
        $messageError.text($messageField.data('missing-error')).show();
        if (!scrollTarget) {
            scrollTarget = $messageField;
        }
    } else {
        $messageField.removeClass('is-invalid');
        $messageError.text('').hide();
    }

    var formData = {
        title: $('#catalogueRequestForm .requestcatalogue-fname-group .selected-value').text(),
        firstName: $('#catalogueFirstName').val().trim(),
        lastName: $('#catalogueLastName').val().trim(),
        email: $('#catalogueEmail').val().trim(),
        countryCode: $('#requestCatalogueModal .country-code .selected-value').text().trim(),
        phone: $('#cataloguePhone').val().trim(),
        message: $('#catalogueMessage').val().trim()
    };

    var $formData = formData;
    if (isFormValid) {
        submitCatalogueRequest($formData);
    } else if (scrollTarget) {
        var $targetGroup = scrollTarget.closest('.form-group');
        var $target = $targetGroup.length ? $targetGroup : scrollTarget;
        if ($scrollContainer.length) {
            var offsetTop = $target.position().top;
            // Scroll modal body to highlight the first invalid field
            $scrollContainer.animate({
                scrollTop: $scrollContainer.scrollTop() + offsetTop - 40
            }, 400);
        } else {
            $('html, body').animate({
                scrollTop: $target.offset().top - 120
            }, 400);
        }
    }
});

$('body').on('hidden.bs.modal', '#requestCatalogueModal', function () {
    clearForm();
});

$('body').on('click', '#requestCatalogueModal .cancel-btn', function () {
    clearForm();
});

$('body').on('shown.bs.modal', '#requestCatalogueModal', function () {
    var modaldataurl = $('#requestCatalogueModalURL').val();
    var url = modaldataurl;
    $.ajax({
        url: url,
        method: 'get',
        success: function (response) {
            if (response) {
                var parent = $('<div class="modal-placeholder"></div>');
                parent.html(response);
                $('#requestCatalogueModal').find('.modal-content').html(parent.find('.modal-content').html());
            }

            if (isAuthenticated) {
                var countryCode = $('#requestCatalogueMobileDialCode').val();
                if (countryCode) {
                    resetCountryCodeToDefault(countryCode);
                }
            }

            updateSubmitButtonText();
        },
        error: function () {
            toastMessageHelper.showNotification('Something went wrong. Please try again later.');
        }
    });
});

/**
 * Handles window resize events to update button text responsively.
 * Uses debouncing to optimize performance during continuous resize.
 */
var resizeTimer;
$(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        if ($('#requestCatalogueModal').hasClass('show')) {
            updateSubmitButtonText();
        }
    }, 250);
});

$('body').on('change input blur', '#catalogueRequestForm input', function () {
    var $field = $(this);
    var value = $field.val().trim();
    var $placeholder = $field.closest('.form-group').find('.form-check-label.placeholder');
    if (value) {
        $placeholder.addClass('d-none');
    } else {
        $placeholder.removeClass('d-none');
    }
});
